import Addressify from '../addressify/addressify';
import GoogleDetailsParser from '../addressify/google/google_details_parser';
import GoogleDetails from '../addressify/google/google_details';

class CheckoutAddressify {
	constructor(inputs) {
		'use strict';

		this.inputs = {
			//Cache Billing Inputs
			$billingStreet: $('#billingStreet'),
			$billingStreetNumber: $('#billingStreetNumber'),
			$billingPostCode: $('#billingPostCode'),
			$billingCity: $('#billingCity'),
			$billingState: $('#billingState'),
			$billingDisplayStreet: $('#billingDisplayStreet'),
			billingManualTrigger: {
				changeBtn: $('#billing-address-manual-change'),
				addressInput: $('.order__step-content--billing-address-change'),
				addressContainer: $('.city')
			},
			...inputs
		};

		if (true === CheckoutAddressify.showSuburb()) {
			if (!this.inputs.$billingSuburb) {
				Object.assign(this.inputs, {
					$billingSuburb: $('#billingSuburb')
				});
			}
		}

		this.actions = {
			overwrite: 'overwrite',
			prepend: 'prepend',
			append: 'append'
		};

		this.detailsProvider = null;
		this.detailsParser = new GoogleDetailsParser();
		this.addressifyHandlers = {};

		this.displayStreetObj = {
			$billingCity: this.inputs.$billingCity.val(),
			$billingState: this.inputs.$billingState.val(),
			$billingPostCode: this.inputs.$billingPostCode.val()
		};

		if (true === CheckoutAddressify.showSuburb()) {
			this.displayStreetObj = { $billingSuburb: this.inputs.$billingSuburb.val(), ...this.displayStreetObj };
		}

		if (this.displayStreetObj.$billingCity) {
			this.setDisplayStreet('$billingCity', this.inputs.$billingCity.val());
		}

		$(this.inputs.billingManualTrigger.changeBtn).click((e) => {
			e.preventDefault();
			$(this.inputs.billingManualTrigger.addressInput).hide();
			$(this.inputs.billingManualTrigger.addressContainer).removeClass('hidden');
		});
	}

	init() {
		'use strict';
		this.initBillingAddressify('$billingStreet');
		this.initInputs();
		this.initDetailsProvider();
	}

	/**
	 * @return {CheckouAddressify}
	 */
	initDetailsProvider() {
		'use strict';

		this.detailsProvider = new GoogleDetails();
		return this;
	}

	/**
	 * No operation
	 * @return {null}
	 */
	noop() { }

	initInputs() {
		'use strict';
		for (var i in this.inputs) {
			if (typeof this.inputs[i] === 'object' &&
				this.inputs[i] !== null &&
				this.inputs[i].length) {
				this.inputs[i].on('focus', this.hideHandlers.bind(this));
				this.inputs[i].on('blur', this.hideHandlers.bind(this));
			}
		}
	}

	hideHandlers() {
		'use strict';

		setTimeout(() => {
			for (var inputName in this.addressifyHandlers) {
				this.addressifyHandlers[inputName].hideResults();
			}
		}, 500);
	}

	static showSuburb() {
		return ['NZ', 'NZ_SCA'].indexOf(TYROOLA.globals.store) >= 0;
	}

	/**
	 * @param  {String} addressType
	 * @return {Object}
	 */
	outputMap(addressType) {
		'use strict';

		return {
			'subpremise': $.proxy(this.setSubpremise, this, '$' + addressType + 'Street', this.actions.overwrite),
			'street_number': $.proxy(this.setStreetNum, this, '$' + addressType + 'Street', this.actions.overwrite),
			'route': $.proxy(this.setStreet, this, '$' + addressType + 'Street', null),
			'locality': $.proxy(this.setField, this, '$' + addressType + 'City', this.actions.overwrite),
			'sublocality_level_1': $.proxy(this.setField, this, '$' + addressType + 'Suburb', this.actions.overwrite),
			'administrative_area_level_1': $.proxy(this.setField, this, '$' + addressType + 'State', this.actions.overwrite),
			'postal_code': $.proxy(this.setField, this, '$' + addressType + 'PostCode', this.actions.overwrite),
			'country': this.noop
		};

	}

	/**
	 * Dynamically generate results space
	 * @return {[type]}
	 */
	outputParsedAddresss(addressType, $input, details) {
		'use strict';

		var outputMap, address, field, sortedAddress;

		outputMap = this.outputMap(addressType);
		address = this.detailsParser.parse(details);
		sortedAddress = this.sortFields(address);

		this.streetNumSet = false;

		for (var i in sortedAddress) {
			field = (Object.keys(sortedAddress[i]))[0];
			if (outputMap[field]) {
				outputMap[field](sortedAddress[i][field]);
			}
		}

		$input.removeClass('loading-small');

	}

	/**
	 * @param {Object} fields
	 * @param {Array} value
	 */
	sortFields(fields) {
		'use strict';

		var fieldName,
			field,
			sortedResult = [],
			orderedFields = [
				'subpremise',
				'street_number',
				'route',
				'locality',
				'sublocality_level_1',
				'administrative_area_level_1',
				'country',
				'postal_code',
			];

		for (var i in orderedFields) {
			fieldName = orderedFields[i];
			if (!fields[fieldName]) {
				continue;
			}

			field = {};
			field[fieldName] = fields[fieldName];
			sortedResult.push(field);

		}

		return sortedResult;
	}

	/**
	 * @param {String} $fieldRef
	 * @param {String} actionType
	 * @param {String} value
	 */
	setField($fieldRef, actionType, value) {
		'use strict';

		if (!this.inputs[$fieldRef]) {
			return;
		}
		this.setDisplayStreet($fieldRef, value);

		this[actionType](this.inputs[$fieldRef], value);
	}

	/**
	 * @param {String} $fieldRef
	 * @param {String} actionType
	 * @param {String} value
	 */
	setSubpremise($fieldRef, actionType, value) {
		'use strict';

		//Cache this for Street setting
		this.subpremiseSet = true;

		this.setField($fieldRef, actionType, value);
	}

	/**
	 * @param {String} $fieldRef
	 * @param {String} actionType
	 * @param {String} value
	 */
	setStreetNum($fieldRef, actionType, value) {
		'use strict';

		//Cache this for Street setting
		this.streetNumSet = true;

		//We want	 to append if we have a street number as we've already overriden user input
		//Otherwie we can overrite
		if (this.subpremiseSet) {
			actionType = this.actions.append;
			value = '/ ' + value;
		}
		else {
			actionType = this.actions.overwrite;
		}

		this.setField($fieldRef, actionType, value);
	}

	/**
	 * @param {String} $fieldRef
	 * @param {String} actionType
	 * @param {String} value
	 */
	setStreet($fieldRef, actionType, value) {
		'use strict';

		//We want to append if we have a street number as we've already overriden user input
		//Otherwie we can overrite
		if (this.streetNumSet || this.subpremiseSet) {
			actionType = this.actions.append;
		}
		else {
			actionType = this.actions.overwrite;
		}

		this.setField($fieldRef, actionType, value);
	}

	/**
	 * @param {String} field
	 * @param {String} value
	 */
	setDisplayStreet(field, value) {
		'use strict';

		this.displayStreetObj[field] = value;
		let billingSuburb = '';
		if (CheckoutAddressify.showSuburb()) {
			billingSuburb = ', ' + this.displayStreetObj.$billingSuburb;
		}

		var output = this.displayStreetObj.$billingPostCode
			+ billingSuburb
			+ ', ' + this.displayStreetObj.$billingCity
			+ ', ' + this.displayStreetObj.$billingState;
		this.overwrite(this.inputs['$billingDisplayStreet'], output);
	}

	/**
	 * @param  {Object} $field [jQuery]
	 * @param  {String} value
	 * @return {CheckoutAddressify}
	 */
	overwrite($field, value) {
		'use strict';
		$field.val(value);
		return this;
	}

	/**
	 * @param  {Object} $field [jQuery]
	 * @param  {String} value
	 * @return {CheckoutAddressify}
	 */
	prepend($field, value) {
		'use strict';
		$field.val(value + ' ' + $.trim($field.val()));
		return this;
	}

	/**
	 * @param  {Object} $field [jQuery]
	 * @param  {String} value
	 * @return {CheckoutAddressify}
	 */
	append($field, value) {
		'use strict';
		$field.val($.trim($field.val()) + ' ' + value);
	}

	/**
	 * Create Addressfiy instance for given input name
	 * @param  {String} inputName
	 */
	initBillingAddressify(inputName) {
		'use strict';

		var billingAddressify = new Addressify(
			this.inputs[inputName],
			null,
			$.proxy(this.billingTermProvider, this)
		);

		billingAddressify.init();

		billingAddressify.observe($.proxy(this.getDetails, this, 'billing', this.inputs[inputName]));

		this.addressifyHandlers[inputName] = billingAddressify;
	}

	/**
	 * Create Addressfiy instance for given input name
	 * @param  {String} inputName
	 */
	initShippingAddressify(inputName) {
		'use strict';

		var shippingAddressify = new Addressify(
			this.inputs[inputName],
			null,
			$.proxy(this.shippingTermProvider, this)
		);

		shippingAddressify.init();

		shippingAddressify.observe($.proxy(this.getDetails, this, 'shipping', this.inputs[inputName]));

		this.addressifyHandlers[inputName] = shippingAddressify;
	}

	/**
	 * @return {String}
	 */
	billingTermProvider() {
		'use strict';
		return this.inputs['$billingStreet'].val();
	}

	/**
	 * @return {String}
	 */
	shippingTermProvider() {
		'use strict';
		return this.inputs['$shippingStreet'].val();
	}

	/**
	 * @param  {String} addressType
	 * @param  {Object} $input      [jQuery]
	 * @param  {String} address
	 */
	getDetails(addressType, $input, address, placeId) {
		'use strict';
		$input.addClass('loading-small');
		this.detailsProvider.get(placeId, $.proxy(this.outputParsedAddresss, this, addressType, $input));
	}

	/**
	 * @return {Boolean}
	 */
	isActive() {
		'use strict';
		for (var inputName in this.addressifyHandlers) {
			if (this.addressifyHandlers[inputName].isActive()) {
				return true;
			}
		}
		return false;
	}

	/**
	 * @return {Boolean}
	 */
	isBillingFormComplete() {
		'use strict';

		return Boolean(this.inputs['$billingStreetNumber'].val()) &&
			Boolean(this.inputs['$billingStreet'].val()) &&
			Boolean(this.inputs['$billingCity'].val()) &&
			Boolean(this.inputs['$billingPostCode'].val());

	}
}

export default CheckoutAddressify;
